import { Box, Divider, Stack } from "../";
import { color, Theme } from "@sloth-system/styled-utils";
import React from "react";

interface LogisticTimeLineType {
  disabled?: boolean;
  theme: Theme;
  icon?: React.ReactNode;
  children?: React.ReactNode;
  active?: boolean;
  activeIcon?: React.ReactNode;
}

function LogisticTimeLine(props: LogisticTimeLineType) {
  return React.Children.map(props.children, (item) => {
    if (item) {
      let active = item.props.active || props.active;
      let { line = true } = item.props;
      let borderWidth = active ? 2 : 1;
      if (!line) {
        borderWidth = 0;
      }

      return (
        <Stack
          style={{ width: "100%", position: "relative" }}
          alignment="stretch"
          px="xxl"
        >
          <Box
            style={{
              alignItems: "center",
              paddingTop: 6,
            }}
          >
            {active ? props.activeIcon : props.icon}
            <Divider size="s" />
            <Box
              style={{
                width: 1,
                flexGrow: 1,
                borderRightWidth: borderWidth,
                borderRightRadius: 1,
                borderRightStyle: active ? "solid" : "dashed",
                borderRightColor: active
                  ? color("neutrals.250")({ theme: props.theme })
                  : color("text.light950")({ theme: props.theme }),
              }}
            />
          </Box>
          {item}
        </Stack>
      );
    } else {
      return null;
    }
  });
}

export default LogisticTimeLine;
